export default {
  DETAIL_LOAD: 'ACTION_DETAIL_ID_LOAD',
  DETAIL_FETCHED: 'ACTION_DETAIL_ID_FETCHED',
  BUTTON_LOAD: 'ACTIVE_ACTIONS_BUTTON_LOAD',
};
